import { Box, Breakpoint, Container } from "@mui/material";
import React, { FC, ReactNode } from "react";
import { Text } from "../Typography";

interface IHeader {
  logo: any;
  logoStyles?: any;
  children?: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  isEmployer?: boolean;
  employerTagLine?: string;
};

export const Header: FC<IHeader> = ({ logo, logoStyles, children, maxWidth = "lg", isEmployer = false, employerTagLine }) => {
  const classes = {
    root: {
      background: '#fff',
      position: 'sticky',
      top: 0,
      zIndex:1,
      left: 0,
      height: '67px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
      display: 'flex',
      alignItems: 'center'
    },

    logoStyles: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      ...logoStyles,
    }
  }

  return (
    <Box sx={classes.root}>
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
        maxWidth={maxWidth}
      >
        <Box
          display='flex'
          alignItems='center'
        >
          <Box style={classes.logoStyles}>
            {logo}
          </Box>
          {isEmployer && (
            <Text sx={{
              ml: 4,
              position: 'relative',

              '&:before': {
                position: 'absolute',
                content: '""',
                height: '42px',
                top: '50%',
                left: '-16px',
                transform: 'translateY(-50%)',
                width: '1px',
                background: '#292929'
              },
            }}>{employerTagLine || 'Employers Zone'}</Text>
          )}
        </Box>

        {children && (
          <Box
            display='flex'
            ml='auto'
            alignItems='center'
          >
            {children}
          </Box>
        )}
      </Container>
    </Box>
  )
};
